import {UseMutationOptions, useMutation} from '@tanstack/react-query';
import {axiosBffFetch} from '../../../axios/axiosBffFetch';

const useCreateAskMutationHook = (
  options?: UseMutationOptions<any, unknown, FormData>
) =>
  useMutation({
    mutationFn: async data => {
      const result = await axiosBffFetch('/api/ask/create', {
        method: 'POST',
        data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return result.data.data;
    },
    ...options,
  });

export default useCreateAskMutationHook;
